// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__headerLink___ve6as {
  margin-top: 8px;
}

.styles__section___zlOk0 {
  background-color: white;
  padding: 10px 10px 20px;
  width: 100%;
}

.styles__tableSection___sJnj0 {
  background-color: white;
  margin-bottom: 20px;
  /* position: relative; */
}

.styles__tableTitle___ROCgG {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]};
  border-radius: 3px 3px 0 0;
  box-shadow: 0 1px 0 0 rgba(58, 64, 68, 0.1);
  height: 50px;
  margin-bottom: 1px;
  padding: 16px 20px;
}

.styles__row___Ay0wz {
  align-items: center;
  padding: 12px 10px;
}

.styles__row___Ay0wz:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
.styles__actionIcons___oi1D7 img {
    height: 16px;
    width: 16px;
  }

.styles__label___zO3Tb {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
}

.styles__table___UHPu8 {
  display: table;
  width: 100%;
}

.styles__thRow___QOccm {
  display: table-row;
}
.styles__disabledButton___klhxR {
  cursor: not-allowed;
  opacity: 0.2;
  pointer-events: none;
}

.styles__tdRow___amxSJ {
  box-shadow: none;
  display: table-row;
  -webkit-text-decoration: none;
  text-decoration: none;
  transition: all 0.25s;
}

.styles__tdRow___amxSJ:hover {
    background: white;
    box-shadow: none;
  }

.styles__selected____AE8Y {
}

.styles__selected____AE8Y .styles__tdCell___hqnz5 {
    background: white;
  }

.styles__selected____AE8Y:hover .styles__tdCell___hqnz5 {
      background: white;
    }

.styles__highlight___FZqkB {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]};
}

.styles__tdCell___hqnz5 {
  background: rgba(255, 255, 255, 0.7);
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  display: table-cell;
  line-height: 24px;
  padding: 10px;
  vertical-align: top;
  max-width: 160px;
}

.styles__tdCell___hqnz5:first-child {
    padding-left: 20px;
  }

.styles__tdCell___hqnz5:last-child {
    padding-right: 20px;
  }

.styles__thCell___pB9YW {
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  color: transparent;
  font-size: 14px;
  line-height: 8px;
  padding-bottom: 16px;
  padding-top: 8px;
  white-space: nowrap;
}

.styles__thCell___pB9YW .styles__fixed___ICZO0 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  }

.styles__thCell___pB9YW:first-child {
    color: transparent;
  }

.styles__thCell___pB9YW:first-child .styles__fixed___ICZO0 {
      color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
    }

.styles__thCell___pB9YW .styles__thCellSpan___MwNEB {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

.styles__tableTickets___PTSFC {
}

.styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(2),
    .styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(3) {
      width: calc(99.9% * 2/5 - (30px - 30px * 2/5));
    }

.styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(2):nth-child(1n),
    .styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(3):nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(2):last-child,
    .styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(3):last-child {
      margin-right: 0;
    }

.styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(2):nth-child(5n),
    .styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(3):nth-child(5n) {
      margin-right: 0;
      float: right;
    }

.styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(2):nth-child(5n + 1),
    .styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(3):nth-child(5n + 1) {
      clear: both;
    }

.styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(1) {
      width: calc(99.9% * 1/5 - (30px - 30px * 1/5));
    }

.styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(1):nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(1):last-child {
      margin-right: 0;
    }

.styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(1):nth-child(5n) {
      margin-right: 0;
      float: right;
    }

.styles__tableTickets___PTSFC .styles__tdCell___hqnz5:nth-child(1):nth-child(5n + 1) {
      clear: both;
    }

.styles__tableAccounts___fnlnz .styles__tdRow___amxSJ {
    cursor: pointer;
  }

.styles__tableFees___QA1jI {
}

.styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(2) {
      width: calc(99.9% * 2/5 - (30px - 30px * 2/5));
    }

.styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(2):nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(2):last-child {
      margin-right: 0;
    }

.styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(2):nth-child(5n) {
      margin-right: 0;
      float: right;
    }

.styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(2):nth-child(5n + 1) {
      clear: both;
    }

.styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(1),
    .styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(3),
    .styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(4) {
      width: calc(99.9% * 1/5 - (30px - 30px * 1/5));
    }

.styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(1):nth-child(1n),
    .styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(3):nth-child(1n),
    .styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(4):nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(1):last-child,
    .styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(3):last-child,
    .styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(4):last-child {
      margin-right: 0;
    }

.styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(1):nth-child(5n),
    .styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(3):nth-child(5n),
    .styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(4):nth-child(5n) {
      margin-right: 0;
      float: right;
    }

.styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(1):nth-child(5n + 1),
    .styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(3):nth-child(5n + 1),
    .styles__tableFees___QA1jI .styles__tdCell___hqnz5:nth-child(4):nth-child(5n + 1) {
      clear: both;
    }

.styles__docRow___AVmo_ {
  padding: 12px 10px;
}

.styles__docRow___AVmo_:last-child {
    padding-bottom: 0;
  }

.styles__docLabel___CLltv {
  margin-bottom: 3px;
}

.styles__pending___wpLJg,
.styles__incomplete___D4xeT {
}

.styles__active___ZienC,
.styles__approved___hKbKW,
.styles__complete___T9So0 {
}

.styles__closed___yayqJ,
.styles__rejected___ebBXn {
}

.styles__tableDefault___lTrBz {
  border-radius: 0 0 3px 3px;
  overflow-y: auto;
}

.styles__tableLarge___OmH6i {
  max-height: 75vh;
}

.styles__tableMedium___ChIyM {
  max-height: 300px;
}

.styles__tableSmall___tL2ox {
  max-height: 203px;
}

.styles__button___vspbg {
}

.styles__button___vspbg > span {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    border-radius: 3px;
    color: white;
    cursor: pointer;
    display: inline-block;
    font-size: 12px;
    line-height: initial;
    padding: 4px 8px;
    transition: all 0.25s;
  }

.styles__button___vspbg > span:hover {
      opacity: 0.9;
    }

.styles__button___vspbg > span div {
      border-bottom: none;
      cursor: pointer;
      margin: 0;
      padding: 0;
    }

.styles__remove___h7iEB span {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
    border: none;
    border-radius: 3px;
    box-shadow: none;
    color: white;
    cursor: pointer;
    display: inline-block;
    font-size: 13px;
    font-weight: 700;
    padding: 0 0.5em;
    -webkit-text-decoration: none;
    text-decoration: none;
    text-shadow: none;
    transition: all 0.25s;
    width: auto;
  }

.styles__remove___h7iEB span:hover {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
      box-shadow: none;
    }

.styles__remove___h7iEB span:active,
    .styles__remove___h7iEB span:focus {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
      border: none;
    }

.styles__noResults____YF74 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
}

.styles__noValue___VM1Jn {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
}

.styles__boldValue____2XLL {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
  font-weight: bold;
}

.styles__monoValue___PD5wL {
  font-family: MaisonMono, monospace;
  text-align: right;
}

.styles__centeredValue___i1p2P {
  font-family: MaisonMono, monospace;
  text-align: center;
}

.styles__gpt____4opV {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]};
  border-radius: 3px;
  box-shadow: none;
  color: white;
  display: inline-block;
  font-family: MaisonNeue, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: normal;
  padding: 2px 4px;
  transition: all 0.25s;
}

.styles__gpt____4opV:hover {
    background: #253a4f;
  }

.styles__gpt____4opV a {
    box-shadow: none;
    color: white;
    display: block;
    font-size: 13px;
    left: -4px;
    padding: 1px;
    position: relative;
    text-align: center;
    width: calc(100% + 8px);
  }

.styles__floatRight___Kd49i {
  text-align: right;
  width: 100%;
}

.styles__cellBtn___HnFUc {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  font-weight: 600;
}

.styles__cellBtn___HnFUc:hover {
    cursor: pointer;
    -webkit-text-decoration: underline;
    text-decoration: underline;
  }

.styles__arrowIcons___bWEuF {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-left: 2px;
}
`, "",{"version":3,"sources":["webpack://./universal/components/Table/styles.css"],"names":[],"mappings":"AAIA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EAEvB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,uBAAuB;EAEvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,8DAAgC;EAChC,0BAA0B;EAC1B,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EAEnB,kBAAkB;AAMpB;;AAJE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;AAGA;IACE,YAAY;IACZ,WAAW;EACb;;AAGF;EACE,oDAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAAqB;EAArB,qBAAqB;EACrB,qBAAqB;AAMvB;;AAJE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;AAYA;;AATE;IACE,iBAAiB;EACnB;;AAGE;MACE,iBAAiB;IACnB;;AAIJ;EACE,+DAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,qEAAoC;EACpC,oDAAW;EAEX,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AASlB;;AAPE;IACE,kBAAkB;EACpB;;AAEA;IACE,mBAAmB;EACrB;;AAGF;EACE,qEAAoC;EACpC,kBAAkB;EAElB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AAkBrB;;AAhBE;IACE,oDAAW;EACb;;AAEA;IACE,kBAAkB;EAKpB;;AAHE;MACE,oDAAW;IACb;;AAEF;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;EACzB;;AAGF;AAaA;;AATI;;MAEE,8CAAgB;IAClB;;AAHA;;MAEE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;AAHA;;MAEE,eAAgB;IAClB;;AAHA;;MAEE,eAAgB;MAAhB,YAAgB;IAClB;;AAHA;;MAEE,WAAgB;IAClB;;AAEA;MACE,8CAAgB;IAClB;;AAFA;MACE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;AAFA;MACE,eAAgB;IAClB;;AAFA;MACE,eAAgB;MAAhB,YAAgB;IAClB;;AAFA;MACE,WAAgB;IAClB;;AAKF;IACE,eAAe;EACjB;;AAGF;AAcA;;AAVI;MACE,8CAAgB;IAClB;;AAFA;MACE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;AAFA;MACE,eAAgB;IAClB;;AAFA;MACE,eAAgB;MAAhB,YAAgB;IAClB;;AAFA;MACE,WAAgB;IAClB;;AAEA;;;MAGE,8CAAgB;IAClB;;AAJA;;;MAGE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;AAJA;;;MAGE,eAAgB;IAClB;;AAJA;;;MAGE,eAAgB;MAAhB,YAAgB;IAClB;;AAJA;;;MAGE,WAAgB;IAClB;;AAIJ;EACE,kBAAkB;AAKpB;;AAHE;IACE,iBAAiB;EACnB;;AAGF;EAEE,kBAAkB;AACpB;;AAEA;;AAGA;;AAEA;;;AAIA;;AAEA;;AAGA;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;AAyBA;;AAtBE;IACE,8DAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;EAYvB;;AAVE;MACE,YAAY;IACd;;AAEA;MACE,mBAAmB;MACnB,eAAe;MACf,SAAS;MACT,UAAU;IACZ;;AAKF;IACE,8DAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,6BAAqB;IAArB,qBAAqB;IACrB,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;EAYb;;AAVE;MACE,yDAAqB;MACrB,gBAAgB;IAClB;;AAEA;;MAEE,yDAAqB;MACrB,YAAY;IACd;;AAIJ;EACE,oDAAgB;AAElB;;AAEA;EACE,oDAAgB;AAElB;;AAEA;EACE,mDAAiB;EAEjB,iBAAiB;AACnB;;AAEA;EAEE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EAEE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,wDAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AAiBvB;;AAfE;IACE,mBAAmB;EACrB;;AAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;EACzB;;AAGF;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mDAAa;EACb,gBAAgB;AAKlB;;AAJE;IACE,eAAe;IACf,kCAA0B;IAA1B,0BAA0B;EAC5B;;AAGF;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtBlue, gtBlueDark, borderColor, gtCardHeaderBG, gtGray, gtGreen, gtGPT, gtGreenDark, gtGreenLight, gtRed, gtRedDark, gtYellow, gtYellowLight, text, textLight, textDark from colors;\n\n.headerLink {\n  margin-top: 8px;\n}\n\n.section {\n  background-color: white;\n  composes: boxWrap clearfix from helpers;\n  padding: 10px 10px 20px;\n  width: 100%;\n}\n\n.tableSection {\n  background-color: white;\n  composes: card from helpers;\n  margin-bottom: 20px;\n  /* position: relative; */\n}\n\n.tableTitle {\n  background-color: gtCardHeaderBG;\n  border-radius: 3px 3px 0 0;\n  box-shadow: 0 1px 0 0 rgba(58, 64, 68, 0.1);\n  height: 50px;\n  margin-bottom: 1px;\n  padding: 16px 20px;\n}\n\n.row {\n  align-items: center;\n  composes: row from helpers;\n  padding: 12px 10px;\n\n  &:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n}\n.actionIcons {\n  img {\n    height: 16px;\n    width: 16px;\n  }\n}\n\n.label {\n  color: textLight;\n  font-size: 12px;\n}\n\n.table {\n  display: table;\n  width: 100%;\n}\n\n.thRow {\n  display: table-row;\n}\n.disabledButton {\n  cursor: not-allowed;\n  opacity: 0.2;\n  pointer-events: none;\n}\n\n.tdRow {\n  box-shadow: none;\n  display: table-row;\n  text-decoration: none;\n  transition: all 0.25s;\n\n  &:hover {\n    background: white;\n    box-shadow: none;\n  }\n}\n\n.selected {\n  composes: tdRow;\n\n  .tdCell {\n    background: white;\n  }\n\n  &:hover {\n    .tdCell {\n      background: white;\n    }\n  }\n}\n\n.highlight {\n  background-color: gtYellowLight;\n}\n\n.tdCell {\n  background: rgba(255, 255, 255, 0.7);\n  border-bottom: 1px solid borderColor;\n  color: text;\n  composes: clearfix from helpers;\n  display: table-cell;\n  line-height: 24px;\n  padding: 10px;\n  vertical-align: top;\n  max-width: 160px;\n\n  &:first-child {\n    padding-left: 20px;\n  }\n\n  &:last-child {\n    padding-right: 20px;\n  }\n}\n\n.thCell {\n  border-bottom: 1px solid borderColor;\n  color: transparent;\n  composes: tdCell;\n  font-size: 14px;\n  line-height: 8px;\n  padding-bottom: 16px;\n  padding-top: 8px;\n  white-space: nowrap;\n\n  .fixed {\n    color: text;\n  }\n\n  &:first-child {\n    color: transparent;\n\n    .fixed {\n      color: text;\n    }\n  }\n  .thCellSpan {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n}\n\n.tableTickets {\n  composes: table;\n\n  .tdCell {\n    &:nth-child(2),\n    &:nth-child(3) {\n      lost-column: 2/5;\n    }\n\n    &:nth-child(1) {\n      lost-column: 1/5;\n    }\n  }\n}\n\n.tableAccounts {\n  .tdRow {\n    cursor: pointer;\n  }\n}\n\n.tableFees {\n  composes: table;\n\n  .tdCell {\n    &:nth-child(2) {\n      lost-column: 2/5;\n    }\n\n    &:nth-child(1),\n    &:nth-child(3),\n    &:nth-child(4) {\n      lost-column: 1/5;\n    }\n  }\n}\n\n.docRow {\n  padding: 12px 10px;\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n}\n\n.docLabel {\n  composes: label;\n  margin-bottom: 3px;\n}\n\n.pending,\n.incomplete {\n  composes: statusPending from helpers;\n}\n\n.active,\n.approved,\n.complete {\n  composes: statusActive from helpers;\n}\n\n.closed,\n.rejected {\n  composes: statusRejected from helpers;\n}\n\n.tableDefault {\n  border-radius: 0 0 3px 3px;\n  overflow-y: auto;\n}\n\n.tableLarge {\n  composes: tableDefault;\n  max-height: 75vh;\n}\n\n.tableMedium {\n  composes: tableDefault;\n  max-height: 300px;\n}\n\n.tableSmall {\n  composes: tableDefault;\n  max-height: 203px;\n}\n\n.button {\n  composes: tdCell;\n\n  & > span {\n    background-color: gtBlue;\n    border-radius: 3px;\n    color: white;\n    cursor: pointer;\n    display: inline-block;\n    font-size: 12px;\n    line-height: initial;\n    padding: 4px 8px;\n    transition: all 0.25s;\n\n    &:hover {\n      opacity: 0.9;\n    }\n\n    div {\n      border-bottom: none;\n      cursor: pointer;\n      margin: 0;\n      padding: 0;\n    }\n  }\n}\n\n.remove {\n  span {\n    background-color: gtRed;\n    border: none;\n    border-radius: 3px;\n    box-shadow: none;\n    color: white;\n    cursor: pointer;\n    display: inline-block;\n    font-size: 13px;\n    font-weight: 700;\n    padding: 0 0.5em;\n    text-decoration: none;\n    text-shadow: none;\n    transition: all 0.25s;\n    width: auto;\n\n    &:hover {\n      background: gtRedDark;\n      box-shadow: none;\n    }\n\n    &:active,\n    &:focus {\n      background: gtRedDark;\n      border: none;\n    }\n  }\n}\n\n.noResults {\n  color: textLight;\n  composes: sectionNoMargin from helpers;\n}\n\n.noValue {\n  color: textLight;\n  composes: tdCell;\n}\n\n.boldValue {\n  color: gtBlueDark;\n  composes: tdCell;\n  font-weight: bold;\n}\n\n.monoValue {\n  composes: tdCell;\n  font-family: MaisonMono, monospace;\n  text-align: right;\n}\n\n.centeredValue {\n  composes: tdCell;\n  font-family: MaisonMono, monospace;\n  text-align: center;\n}\n\n.gpt {\n  background: gtGPT;\n  border-radius: 3px;\n  box-shadow: none;\n  color: white;\n  display: inline-block;\n  font-family: MaisonNeue, sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: normal;\n  padding: 2px 4px;\n  transition: all 0.25s;\n\n  &:hover {\n    background: #253a4f;\n  }\n\n  a {\n    box-shadow: none;\n    color: white;\n    display: block;\n    font-size: 13px;\n    left: -4px;\n    padding: 1px;\n    position: relative;\n    text-align: center;\n    width: calc(100% + 8px);\n  }\n}\n\n.floatRight {\n  text-align: right;\n  width: 100%;\n}\n\n.cellBtn {\n  color: gtBlue;\n  font-weight: 600;\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n}\n\n.arrowIcons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin-left: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"borderColor": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]}`,
	"gtCardHeaderBG": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtGPT": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]}`,
	"gtGreenDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenDark"]}`,
	"gtGreenLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenLight"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtRedDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]}`,
	"gtYellow": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]}`,
	"gtYellowLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"textDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]}`,
	"headerLink": `styles__headerLink___ve6as`,
	"section": `styles__section___zlOk0 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["boxWrap"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"tableSection": `styles__tableSection___sJnj0 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["card"]}`,
	"tableTitle": `styles__tableTitle___ROCgG`,
	"row": `styles__row___Ay0wz ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"actionIcons": `styles__actionIcons___oi1D7`,
	"label": `styles__label___zO3Tb`,
	"table": `styles__table___UHPu8`,
	"thRow": `styles__thRow___QOccm`,
	"disabledButton": `styles__disabledButton___klhxR`,
	"tdRow": `styles__tdRow___amxSJ`,
	"selected": `styles__selected____AE8Y styles__tdRow___amxSJ`,
	"tdCell": `styles__tdCell___hqnz5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"highlight": `styles__highlight___FZqkB`,
	"thCell": `styles__thCell___pB9YW styles__tdCell___hqnz5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"fixed": `styles__fixed___ICZO0`,
	"thCellSpan": `styles__thCellSpan___MwNEB`,
	"tableTickets": `styles__tableTickets___PTSFC styles__table___UHPu8`,
	"tableAccounts": `styles__tableAccounts___fnlnz`,
	"tableFees": `styles__tableFees___QA1jI styles__table___UHPu8`,
	"docRow": `styles__docRow___AVmo_`,
	"docLabel": `styles__docLabel___CLltv styles__label___zO3Tb`,
	"pending": `styles__pending___wpLJg ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusPending"]}`,
	"incomplete": `styles__incomplete___D4xeT ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusPending"]}`,
	"active": `styles__active___ZienC ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"approved": `styles__approved___hKbKW ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"complete": `styles__complete___T9So0 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"closed": `styles__closed___yayqJ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusRejected"]}`,
	"rejected": `styles__rejected___ebBXn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusRejected"]}`,
	"tableDefault": `styles__tableDefault___lTrBz`,
	"tableLarge": `styles__tableLarge___OmH6i styles__tableDefault___lTrBz`,
	"tableMedium": `styles__tableMedium___ChIyM styles__tableDefault___lTrBz`,
	"tableSmall": `styles__tableSmall___tL2ox styles__tableDefault___lTrBz`,
	"button": `styles__button___vspbg styles__tdCell___hqnz5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"remove": `styles__remove___h7iEB`,
	"noResults": `styles__noResults____YF74 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"noValue": `styles__noValue___VM1Jn styles__tdCell___hqnz5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"boldValue": `styles__boldValue____2XLL styles__tdCell___hqnz5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"monoValue": `styles__monoValue___PD5wL styles__tdCell___hqnz5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"centeredValue": `styles__centeredValue___i1p2P styles__tdCell___hqnz5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"gpt": `styles__gpt____4opV`,
	"floatRight": `styles__floatRight___Kd49i`,
	"cellBtn": `styles__cellBtn___HnFUc`,
	"arrowIcons": `styles__arrowIcons___bWEuF`
};
export default ___CSS_LOADER_EXPORT___;
